export enum ReportHeadingTitle {
  TEMPERATURE_RECORD = 'Daily Temperature Record',
  ENERGY = 'Energy Report',
  STORAGE = 'Storage Report',
  INSPECTION = 'Site Inspection Report',
}
